export enum MFieldType {
  CountryCode = 'countryCode',
  State = 'state',
  Email = 'email',
  PhoneTel = 'tel',
  IssuerBank = 'issuerBank',
  ZipCode = 'zipCode',
  Text = 'text',
}
